/* Arurmis 79 \u00b7 custom gift box builder
   Adds the chosen 30 ml bottles to the Shopify cart, labelled with the box,
   plus the optional gift box product carrying To / From / Message. */
(function () {
  function money(cents, fmt) {
    fmt = fmt || 'Rs {{amount_no_decimals}}';
    const n = cents / 100;
    const group = (x, d, t, dec) => { const p = x.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(dec); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: group(n, 2, ',', '.'), amount_no_decimals: group(n, 0, ',', '.'),
      amount_with_comma_separator: group(n, 2, '.', ','), amount_no_decimals_with_comma_separator: group(n, 0, '.', ','),
      amount_with_apostrophe_separator: group(n, 2, "'", '.')
    })[k] || group(n, 2, ',', '.'));
  }
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const glow = s => s === 'him' ? '63,191,138' : '128,118,255';

  function init(root) {
    if (root.__gb) return; root.__gb = true;
    const D = JSON.parse(root.querySelector('[data-gb-data]').textContent);
    const F = D.fragrances, B = D.boxes.filter(b => b.name && b.n > 0);
    const st = { box: Math.min(1, B.length - 1), items: [], filter: 'all', busy: false };
    const $ = sel => root.querySelector(sel);
    const fr = id => F.find(f => f.id === id);
    const fmt = c => money(c, D.moneyFormat);
    const toast = (m, link) => { if (window.arurmisToast) window.arurmisToast(m, link); };

    function totals() {
      const b = B[st.box], sub = st.items.reduce((a, id) => a + fr(id).price, 0);
      const save = Math.round(sub * b.save / 100 / 100) * 100;
      return { b, sub, save, total: sub - save, full: st.items.length === b.n, left: b.n - st.items.length };
    }
    function render() {
      const T = totals(), b = T.b;
      $('[data-gb-sizes]').innerHTML = B.map((x, i) => `<button type="button" class="gb-size${i === st.box ? ' on' : ''}" role="radio" aria-checked="${i === st.box}" data-gbbox="${i}">
        <span class="gb-mini" aria-hidden="true">${'<i></i>'.repeat(x.n)}</span><b>${esc(x.name)}</b><small>${x.n} \u00d7 ${esc(D.size)}</small>${x.save ? `<em>Save ${x.save}%</em>` : ''}</button>`).join('');
      $('[data-gb-count]').textContent = T.full ? 'Your box is full' : `${st.items.length} of ${b.n} chosen`;
      const list = F.filter(f => st.filter === 'all' || f.side === st.filter);
      $('[data-gb-grid]').innerHTML = list.length ? list.map(f => {
        const n = st.items.filter(x => x === f.id).length;
        const ctl = n ? `<div class="gb-step-ctl"><button type="button" data-gbrm="${f.id}" aria-label="Remove one ${esc(f.name)}">\u2212</button><span>${n}</span><button type="button" data-gbadd="${f.id}" aria-label="Add another ${esc(f.name)}"${T.full ? ' disabled' : ''}>+</button></div>`
                      : `<button type="button" class="btn btn-line" data-gbadd="${f.id}"${T.full ? ' disabled' : ''}>${T.full ? 'Box full' : 'Add to box'}</button>`;
        return `<article class="gb-card${n ? ' in' : ''}" style="--pglow:${glow(f.side)};--glow:rgb(${glow(f.side)})"><span class="bottle sm" aria-hidden="true"></span><b>${esc(f.name)}</b>${f.tag ? `<small>${esc(f.tag)}</small>` : ''}<span class="gb-p">${fmt(f.price)} \u00b7 ${esc(D.size)}</span>${ctl}</article>`;
      }).join('') : '<p class="empty-note">No fragrances with a 30 ml size are available yet.</p>';
      const slots = [...Array(b.n)].map((_, i) => {
        const id = st.items[i];
        if (!id) return '<span class="gb-slot empty" aria-hidden="true"><i>+</i></span>';
        const f = fr(id);
        return `<button type="button" class="gb-slot" style="--glow:rgb(${glow(f.side)})" data-gbslot="${i}" aria-label="Remove ${esc(f.name)} from the box"><span class="bottle sm"></span><b>${esc(f.name)}</b><span class="x" aria-hidden="true">\u00d7</span></button>`;
      }).join('');
      const counts = {}; st.items.forEach(id => counts[id] = (counts[id] || 0) + 1);
      const lines = Object.entries(counts).map(([id, n]) => { const f = fr(+id); return `<li><span>${esc(f.name)}${n > 1 ? ' \u00d7 ' + n : ''}</span><span>${fmt(f.price * n)}</span></li>`; }).join('');
      $('[data-gb-summary]').innerHTML = `
        <h2 class="gb-sum-title">Your ${esc(b.name)} box</h2>
        <div class="gb-box" style="--n:${b.n}"><div class="gb-lid"><b>ARURMIS 79</b></div><div class="gb-slots">${slots}</div></div>
        <div class="gb-progress" role="progressbar" aria-label="Bottles chosen" aria-valuemin="0" aria-valuemax="${b.n}" aria-valuenow="${st.items.length}"><i style="width:${st.items.length / b.n * 100}%"></i></div>
        <p class="gb-status">${T.full ? 'Ready to add to your bag' : `Choose ${T.left} more ${T.left === 1 ? 'fragrance' : 'fragrances'}`}</p>
        ${lines ? `<ul class="gb-lines">${lines}</ul>` : ''}
        <div class="gb-tot"><span>Subtotal</span><span>${fmt(T.sub)}</span></div>
        ${T.save ? `<div class="gb-tot save"><span>${esc(b.name)} saving (${b.save}%)</span><span>\u2212 ${fmt(T.save)}</span></div>` : ''}
        <div class="gb-tot total"><span>Total</span><span>${fmt(T.total)}</span></div>
        <button type="button" class="btn btn-solid gb-add" data-gb-add${T.full && !st.busy ? '' : ' disabled'}>${st.busy ? 'Adding\u2026' : T.full ? 'Add gift box to bag' : `Choose ${T.left} more`}</button>
        ${st.items.length ? '<button type="button" class="gb-clear" data-gb-clear>Start again</button>' : ''}
        ${D.included ? `<p class="gb-incl">${esc(D.included)}</p>` : ''}`;
      $('[data-gb-bar]').innerHTML = `<div><b>${T.full ? 'Box ready' : `${st.items.length} of ${b.n} chosen`}</b><small>${esc(b.name)} \u00b7 ${fmt(T.total)}</small></div><button type="button" class="btn btn-solid" data-gb-bar-btn>${T.full ? 'Add to bag' : 'View box'}</button>`;
    }

    async function addToBag() {
      const T = totals(); if (!T.full || st.busy) return;
      st.busy = true; render();
      const boxId = Math.random().toString(36).slice(2, 7).toUpperCase();
      const counts = {}; st.items.forEach(id => counts[id] = (counts[id] || 0) + 1);
      const contents = Object.entries(counts).map(([id, n]) => fr(+id).name + (n > 1 ? ' \u00d7 ' + n : '')).join(', ');
      const label = `${T.b.name} box ${boxId}`;
      const items = Object.entries(counts).map(([id, n]) => ({ id: +id, quantity: n, properties: { 'Gift box': label } }));
      const to = ($('[data-gb-to]') || {}).value || '', from = ($('[data-gb-from]') || {}).value || '', note = ($('[data-gb-note]') || {}).value || '';
      if (T.b.variant) {
        const props = { 'Gift box': label, 'Contents': contents };
        if (to.trim()) props['To'] = to.trim();
        if (from.trim()) props['From'] = from.trim();
        if (note.trim()) props['Message'] = note.trim();
        items.push({ id: T.b.variant, quantity: 1, properties: props });
      }
      try {
        const root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add the box');
        if (window.arurmisRefreshCount) await window.arurmisRefreshCount();
        toast('Your gift box is in the bag', true);
        st.items = []; ['[data-gb-to]', '[data-gb-from]', '[data-gb-note]'].forEach(s => { const el = $(s); if (el) el.value = ''; });
        const c = $('[data-gb-note-count]'); if (c) c.textContent = '0';
      } catch (err) {
        toast(err.message || 'Could not add the box', false);
      }
      st.busy = false; render();
    }

    root.addEventListener('click', e => {
      const bx = e.target.closest('[data-gbbox]');
      if (bx) { const i = +bx.dataset.gbbox, n = B[i].n; const cut = st.items.length > n; st.box = i; if (cut) { st.items = st.items.slice(0, n); toast(`Box changed to ${B[i].name}. Extra bottles were removed.`); } render(); return; }
      const ad = e.target.closest('[data-gbadd]');
      if (ad) { if (st.items.length < B[st.box].n) { st.items.push(+ad.dataset.gbadd); render(); if (st.items.length === B[st.box].n) toast('Your box is full. Add a message or add it to your bag.'); } return; }
      const rm = e.target.closest('[data-gbrm]');
      if (rm) { const i = st.items.lastIndexOf(+rm.dataset.gbrm); if (i > -1) st.items.splice(i, 1); render(); return; }
      const sl = e.target.closest('[data-gbslot]');
      if (sl) { st.items.splice(+sl.dataset.gbslot, 1); render(); return; }
      const ch = e.target.closest('[data-gbf]');
      if (ch) { st.filter = ch.dataset.gbf; root.querySelectorAll('[data-gbf]').forEach(c => { c.classList.toggle('on', c === ch); c.setAttribute('aria-pressed', c === ch); }); render(); return; }
      if (e.target.closest('[data-gb-add]')) addToBag();
      if (e.target.closest('[data-gb-clear]')) { st.items = []; render(); }
      if (e.target.closest('[data-gb-bar-btn]')) { if (totals().full) addToBag(); else $('[data-gb-summary]').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    const note = $('[data-gb-note]');
    if (note) note.addEventListener('input', () => { const c = $('[data-gb-note-count]'); if (c) c.textContent = note.value.length; });
    render();
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-giftbox]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
